import axios, { AxiosRequestConfig } from 'axios';
import config from 'appconfig';

import paramsSerializer from 'util/paramsSerializer';
import { baseProductApiUrl } from './mac';

const getPadresClient = (clientConfig: AxiosRequestConfig = {}) => {
  return axios.create({
    baseURL: `${config.hamsUrl}${baseProductApiUrl}`,
    maxContentLength: 50000,
    withCredentials: false,
    paramsSerializer,
    ...clientConfig,
  });
};

export default getPadresClient;
